<template>
  <div>
    <v-progress-linear
      v-if="isVisible"
      indeterminate
      color="primary"
      height="2"
    />
  </div>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{ isVisible?: boolean }>(), { isVisible: true });
</script>
